import React from 'react';
import cinema from "../assets/img/images/autodesk2.jpg";
import img from "../assets/img/images/autodesk3.jpg";

const Cinema = () => {
  return (
    <div style={styles.background}>
      <div style={styles.container}> {/* Wrapper for max width */}
        <h1 style={styles.header}>Cinema 4D Overview</h1>
        <p style={styles.paragraph}>
          Cinema 4D is a 3D modeling, animation, and rendering program used by professionals in many industries. It's known for being easy to learn and use.
        </p>

        <div style={styles.imageCentered}>
          <img
            src={cinema}
            alt="Cinema 4D Visual"
            style={styles.fullWidthImage}
          />
        </div>

        <h2 style={styles.subHeader}>What It's Used For</h2>
        <ul style={styles.featureList}>
          <li style={styles.featureItem}>Creating 3D models, animations, and special effects for video games, advertisements, and other media</li>
          <li style={styles.featureItem}>Developing AR/MR/VR experiences</li>
          <li style={styles.featureItem}>Creating motion graphics and visual effects</li>
          <li style={styles.featureItem}>Simulating natural elements like fire, cloth, and soft bodies</li>
        </ul>

        <h2 style={styles.subHeader}>Key Features</h2>
        <div style={styles.flexRow}>
          <ul style={{ ...styles.featureList, ...styles.flexItem }}>
            <li style={styles.featureItem}>High-resolution textures</li>
            <li style={styles.featureItem}>Complex animations</li>
            <li style={styles.featureItem}>XPresso, a visual node-based expressions editor</li>
            <li style={styles.featureItem}>Particles to interact with simulations</li>
            <li style={styles.featureItem}>Property transfer to move tag data between objects</li>
          </ul>

          <div style={styles.flexItem}>
            <img
              src={img}
              alt="Key Features"
              style={styles.sideImage}
            />
          </div>
        </div>

        <h2 style={styles.subHeader}>Who Uses It?</h2>
        <p style={styles.paragraph}>
          Designers, Motion graphics artists, VFX artists, Game developers, and Visualization professionals.
        </p>

        <h2 style={styles.subHeader}>Integration with Other Programs</h2>
        <ul style={styles.featureList}>
          <li style={styles.featureItem}>You can create Cinema 4D files (.c4d) from within Adobe After Effects</li>
          <li style={styles.featureItem}>You can use Cinema 4D and After Effects together to work with complex 3D elements, scenes, and animations</li>
        </ul>

        <h2 style={styles.subHeader}>Where to Learn More</h2>
        <p style={styles.paragraph}>
          You can learn more about Cinema 4D through classes and other learning formats.
        </p>

        <p style={styles.paragraph}>
          You can check out Maxon's Cinema 4D downloads{' '}
          <a
            href="https://www.maxon.net/en/cinema-4d"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
          >
            here
          </a>.
        </p>
      </div>
    </div>
  );
};

const styles = {
  background: {
    padding: '30px',
    fontFamily: "'Poppins', sans-serif",
    backgroundColor: "#f9fafb",
  },
  container: {
    maxWidth: '80%',
    margin: '0 auto',
  },
  header: {
    fontWeight: 'bold',
    color: '#7620ff',
    marginBottom: '20px',
    textAlign: 'center',
    marginTop: '5rem',
  },
  subHeader: {
    fontWeight: '600',
    color: '#fdba00',
    marginBottom: '10px',
    marginTop: '30px',
  },
  paragraph: {
    lineHeight: '1.6',
    marginBottom: '20px',
  },
  featureList: {
    listStyleType: 'disc',
    paddingLeft: '20px',
    marginBottom: '20px',
  },
  featureItem: {
    marginBottom: '10px',
    lineHeight: '1.5',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  flexItem: {
    minWidth: '380px',
  },
  sideImage: {
    width: '100%',
    maxWidth: '100%',
    borderRadius: '8px',
    objectFit: 'cover',
  },
  fullWidthImage: {
    width: '100%',
    height: 'auto',
    borderRadius: '8px',
    marginBottom: '20px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
  },
  imageCentered: {
    textAlign: 'center',
    marginBottom: '30px',
  },
  link: {
    color: '#FFD700',
    textDecoration: 'none',
    fontWeight: 'bold',
    transition: 'color 0.3s ease',
  },
};

export default Cinema;
